/** What a notification is about and where it leads. Pure, so the server and the browser notifier agree. */

export type NotificationCategory = "reservations" | "payments" | "requests" | "chat" | "other";

export const NOTIFICATION_CATEGORIES: NotificationCategory[] = ["reservations", "payments", "requests", "chat", "other"];

/** The category a stored notification type belongs to (chat messages are not stored notifications; they have their own). */
export function categoryForType(type: string): NotificationCategory {
  if (type.startsWith("BOOKING_")) return "reservations";
  if (type.startsWith("PAYMENT_") || type.startsWith("SUBSCRIPTION_") || type.startsWith("PAYOUT_")) return "payments";
  if (type === "ORDER_CREATED" || type.startsWith("SERVICE_REQUEST_") || type.startsWith("ACTIVITY_") || type.startsWith("ENTITLEMENT_")) return "requests";
  return "other";
}

/** The staff page a notification opens; null when it has no page of its own. */
export function pathForEntity(entityType: string | null | undefined, entityId: string | null | undefined): string | null {
  switch (entityType) {
    case "ORDER": return entityId ? `/orders/${entityId}` : null;
    case "BOOKING": return entityId ? `/bookings/${entityId}` : null;
    case "SERVICE_REQUEST": return entityId ? `/service-requests/${entityId}` : null;
    case "ACTIVITY_SESSION": return entityId ? `/activities/${entityId}` : null;
    case "ACTIVITY_BOOKING": return "/activities";
    case "ENTITLEMENT": return entityId ? `/entitlements/${entityId}` : null;
    case "FEEDBACK": return entityId ? `/feedback/${entityId}` : null;
    case "SUBSCRIPTION": return "/subscription";
    case "PAYMENT": return entityId ? `/payments/${entityId}` : null;
    default: return null;
  }
}
